"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.electionSummaryViewModel = electionSummaryViewModel;
const rounds_1 = require("./rounds");
function electionSummaryViewModel(group, election, now = new Date()) {
    const round = election.rounds ? (0, rounds_1.currentRound)(election.rounds, now) : undefined;
    const roundVotingHours = election.rounds?.find((entry) => entry.number === round?.current)?.votingHours;
    return {
        groupKey: group.key,
        title: election.title,
        shortTitle: election.shortTitle,
        description: group.description ?? election.description,
        votingHours: roundVotingHours ?? election.votingHours ?? [],
        round,
        calculatorCount: group.calculators.length,
    };
}
